// Registry for Lab singletons
import LabMetricsReporter from './Lab2MetricsReporter';
var Lab2Registry = /** @class */ (function () {
    function Lab2Registry() {
        this.projectManager = null;
        this.metricsReporter = new LabMetricsReporter();
    }
    Lab2Registry.getInstance = function () {
        if (Lab2Registry._instance === undefined) {
            Lab2Registry.create();
        }
        return Lab2Registry._instance;
    };
    Lab2Registry.hasEnabledProjects = function () {
        return (Lab2Registry._instance !== undefined &&
            Lab2Registry._instance.projectManager !== null);
    };
    Lab2Registry.create = function () {
        Lab2Registry._instance = new Lab2Registry();
    };
    Lab2Registry.prototype.setProjectManager = function (projectManager) {
        this.projectManager = projectManager;
    };
    Lab2Registry.prototype.getProjectManager = function () {
        return this.projectManager;
    };
    Lab2Registry.prototype.clearProjectManager = function () {
        this.projectManager = null;
    };
    Lab2Registry.prototype.getMetricsReporter = function () {
        return this.metricsReporter;
    };
    return Lab2Registry;
}());
export default Lab2Registry;
